import React from 'react';

import { type SingularKeys, Trans } from '@libs/i18n';
import {
  FileDocIcon,
  FilePdfIcon,
  FileXlsIcon,
  ImageIcon,
} from '@phosphor-icons/react';

export const getFileIcon = (mimeType?: string, size = 18): React.ReactNode => {
  if (mimeType?.includes('pdf')) return <FilePdfIcon size={size} />;
  if (mimeType?.includes('excel') || mimeType?.includes('spreadsheetml')) return <FileXlsIcon size={size} />;
  return <FileDocIcon size={size} />;
};

export const getFileIconByExtension = (fileName: string, size = 24): React.ReactNode => {
  const extension = fileName.split('.').pop()?.toLowerCase();
  const props = { size, weight: 'regular' as const };
  switch (extension) {
    case 'pdf': return <FilePdfIcon {...props} />;
    case 'xls':
    case 'xlsx': return <FileXlsIcon {...props} />;
    case 'png':
    case 'jpg':
    case 'jpeg': return <ImageIcon {...props} />;
    case 'doc':
    case 'docx':
    default: return <FileDocIcon {...props} />;
  }
};

export const getFileTypeLabel = (mimeType?: string): React.ReactNode => {
  if (mimeType?.includes('pdf')) return <Trans i18nKey={'chat.file.type.pdf' as SingularKeys} />;
  if (mimeType?.includes('word') || mimeType?.includes('wordprocessingml')) return <Trans i18nKey={'chat.file.type.word' as SingularKeys} />;
  if (mimeType?.includes('excel') || mimeType?.includes('spreadsheetml')) return <Trans i18nKey={'chat.file.type.excel' as SingularKeys} />;
  return <Trans i18nKey={'chat.file.type.document' as SingularKeys} />;
};

export const extractFileExtension = (fileName: string): string => {
  const parts = fileName.split('.');
  return parts[parts.length - 1] || '';
};
